import { format } from "date-fns";
import { useTheme } from "../../context/ThemeContext";
import { getPrimaryBorder, getPrimaryText } from "../../utils/themeUtils";

// Brand colors via --color-primary CSS var. See CLAUDE.md.
const PresetDateRangeFilter = ({
  presetRanges,
  selectedPreset,
  setSelectedPreset,
  setStartDate,
  setEndDate,
}: {
  presetRanges: any[];
  selectedPreset: string | null;
  setSelectedPreset: (val: string | null) => void;
  setStartDate: (val: string) => void;
  setEndDate: (val: string) => void;
}) => {
  const { isDarkMode } = useTheme();

  return (
    <div className="flex gap-2 flex-wrap">
          {presetRanges.map(({ label, getRange }) => (
            <button
              type="button"
              key={label}
              onClick={() => {
                const [start, end] = getRange();
                setStartDate(format(start, "yyyy-MM-dd"));
                setEndDate(format(end, "yyyy-MM-dd"));
                setSelectedPreset(label);
              }}
              className={`px-3 py-1 border rounded transition-all ${
                selectedPreset === label
                  ? "border-[var(--cc-action)] bg-[var(--cc-action)] text-[var(--cc-action-text)]"
                  : `${getPrimaryBorder(isDarkMode)} ${getPrimaryText(isDarkMode)} ${isDarkMode ? "hover:bg-gray-700" : "hover:bg-gray-100"}`
              }`}
            >
              {label}
            </button>
          ))}
    </div>
  );
};

export default PresetDateRangeFilter;
